// дефалтный дескриптор
export const Default = {
    id: 'default',
    api: 'defBridge',
    title: 'default',
  

    items: [{id:'id', },{id:'rt'},{id:'data'}],
  };